module.exports = __webpack_public_path__ + "components/outside-promo-page/static/intro-4ca5eece86f243f4c00e228d26dfa532.svg";